const copies = {
  spCopy: "es",
  enCopy: "en",
  pickALanguagePrompt: {
    spanish: "Elige un idioma antes de sumergirte",
    english: "Pick a language before diving in",
  },

  english: {
    onSubmitCopy: (value: string) => `You searched for ${value}`,
  },
  spanish: {
    onSubmitCopy: (value: string) => `Buscaste ${value}`,
  },
};

export default copies;
